import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import { NotificationContentPartTypeEnum } from "@/apis/model/NotificationContentPartTypeEnum";
import { FHTDeviceType } from "@/models/MessageTypes";
import { object, string, integer, assert as ass, enums, min, optional, array, boolean as _boolean } from "superstruct";
import { assert } from "../common/assert"; //see docs https://docs.superstructjs.org/guides/04-refining-validation

var PostiveIntegerStruct = min(integer(), 1);
var ImagePayloadMetaDataStruct = object({
  name: optional(string()),
  height: PostiveIntegerStruct,
  width: PostiveIntegerStruct,
  size: optional(PostiveIntegerStruct),
  __source: optional(string()),
  format: optional(string()),
  owner: optional(string())
});
var ImagePayloadStruct = object({
  url: string(),
  objId: optional(string()),
  metaData: ImagePayloadMetaDataStruct
});
export function assertValidImageMessage(m) {
  assert(m, "m falsy");
  assert(m._lcfile, "_lcfile falsy");
  ass(m._lcfile, ImagePayloadStruct);
  return m;
}
var NotificationContentPartStruct = object({
  Id: integer(),
  Text: string(),
  Key: optional(string()),
  Type: enums(Object.values(NotificationContentPartTypeEnum))
});
var FhtChatSystemNoticeAttrMessageCustomFieldStruct = object({
  ContentParts: array(NotificationContentPartStruct),
  UserIds: array(integer())
});
var validFhtDeviceTypeValues = Object.values(FHTDeviceType).filter(function (t) {
  return Number(t);
});
var FhtDeviceTypeStruct = enums(validFhtDeviceTypeValues);
var FhtChatRoomStatusAttrStruct = object({
  toPeer: optional(string()),
  dt: optional(FhtDeviceTypeStruct),
  Custom: optional(array(FhtChatSystemNoticeAttrMessageCustomFieldStruct)),
  Other: optional(array(NotificationContentPartStruct)),
  ShowChatRoom: optional(_boolean())
});
export function assertValidChatRoomStatus(a) {
  assert(a, "a falsy");
  ass(a, FhtChatRoomStatusAttrStruct);
  return a;
}